module.exports = __webpack_public_path__ + "img/call.e5cb26f3.svg";